import { forwardRef, type Ref, type SVGProps } from "react";
const IconCommuteFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.007 18.727c1.063 0 2.082.424 2.834 1.18a4.04 4.04 0 0 1 1.173 2.846c0 3.22-4.007 7.247-4.007 7.247S2 25.974 2 22.753c0-2.224 1.794-4.026 4.007-4.026m0 2.415c-.885 0-1.602.722-1.602 1.61A1.6 1.6 0 0 0 7.14 23.89c.3-.3.47-.71.47-1.137 0-.89-.719-1.611-1.604-1.611"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M22.028 2.72a2.44 2.44 0 0 1 3.46 0l4.035 4.055c.636.64.636 1.677 0 2.317-.637.64-1.67.64-2.306 0L25.35 7.216v8.548c0 3.559-2.87 6.443-6.412 6.444-3.484 0-6.331-2.796-6.411-6.296L12.369 9a2.57 2.57 0 0 0-2.563-2.517 2.57 2.57 0 0 0-2.564 2.575v6.444c0 .905-.73 1.639-1.63 1.639S3.98 16.406 3.98 15.5V9.058c0-3.232 2.608-5.852 5.825-5.852 3.165 0 5.752 2.54 5.825 5.72l.155 6.912a3.16 3.16 0 0 0 3.152 3.095 3.16 3.16 0 0 0 3.152-3.168V7.292l-1.79 1.8c-.637.64-1.67.64-2.308 0a1.644 1.644 0 0 1 0-2.317z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconCommuteFilledSVG);
ForwardRef.displayName = "IconCommuteFilled";
export { ForwardRef as IconCommuteFilled };
